export enum DashboardFilter {
    CHASES = "Chases",
    COMPLETED_TODAY = "Completed Today",
}
